export default "__VITE_ASSET__BvFNLBTg__"